import { useQuery } from "@tanstack/react-query";
import api from "../../services/api";

export const useViewSingleIndustry = (id) => {
  return useQuery({
    queryKey: ["industry", id],
    queryFn: async () => {
      const res = await api.get(`/industry/${id}`);
      return res.data;
    },
    enabled: !!id, // prevents unnecessary call
  });
};